<template>
  <div class="product-details-content-register-module-basic">
    <div class="my-6">
      <step-title
        title="Informações básicas"
        description="Configure o módulo"
        icon="fa-solid fa-info"
        fa
      />
    </div>
    <div class="row">
      <div class="col-lg-12">
        <form-group
          v-model="form.name"
          id="name"
          class="mb-5"
          label="Nome do módulo"
          placeholder="Ex: Introdução"
          :errors="errors.name"
          :maxLength="240"
          required
        />
        <div class="d-flex justify-content-end">
          <small
            class="text-secondary text-right mb-5 w-100"
            :class="{
              'text-danger': form.name && form.name.length >= 240
            }"
          >
            {{ `${form.name ? form.name.length : 0}/240` }}
          </small>
        </div>
        <form-group
          v-model="form.description"
          id="description"
          label="Descrição do módulo"
          placeholder="Ex: Módulo de introdução do curso, aqui você aprenderá o que é necessário para..."
          :errors="errors.description"
          textarea
          rows="5"
          :maxLength="255"
        />
        <div class="d-flex justify-content-end">
          <small
            class="text-secondary text-right mb-5 w-100"
            :class="{
              'text-danger': form.description && form.description.length >= 255
            }"
          >
            {{ `${form.description ? form.description.length : 0}/255` }}
          </small>
        </div>
        <action-dispatcher
          action="membersCategories/getAll"
          :parameters="{
            product_id: $route.params.id,
            limit: 500
          }"
        >
          <form-group
            v-model="form.category_ids"
            :errors="errors.category_ids"
            id="categories"
            placeholder="Selecione"
            label="Categoria"
            select
            multiple
            :options="categories"
            suffixLabel="Adicionar categoria"
            @selectSuffixAction="openCategoryModal"
          />
        </action-dispatcher>

        <hr class="my-6" />

        <h6 class="subtitle m-0">
          Liberação do módulo
        </h6>
        <small class="description">
          Determine em quantos dias o seu conteúdo será liberado após a compra.
        </small>

        <b-form-checkbox
          id="_days_to_release"
          v-model="days_to_release"
          switch
          class="mt-6 button"
        >
          Liberar após quantidade de dias
        </b-form-checkbox>

        <div v-if="days_to_release">
          <form-group
            v-model="form.days_to_release"
            :errors="errors.days_to_release"
            id="days_to_release"
            placeholder="0 dias"
            label="Liberar após"
            mask="###"
          />
        </div>

        <b-form-checkbox
          id="_release_at"
          v-model="release_at"
          switch
          class="mt-5 button"
        >
          Liberar em uma data específica
        </b-form-checkbox>

        <div v-if="release_at">
          <form-group
            v-model="form.release_at"
            :errors="errors.release_at"
            id="release_at"
            placeholder="00/00/0000"
            label="Liberar no dia"
            is-date
          />
        </div>
      </div>
    </div>
    <responsive-modal v-model="openModal" size="lg">
      <category-modal
        class="p-5"
        @success="categoryOnSuccess"
        @close="openModal = false"
      />
    </responsive-modal>
  </div>
</template>
<script>
import get from "lodash/get";
import { mapState } from "vuex";
import CategoryModal from "./category/CategoryModal.vue";

export default {
  components: {
    CategoryModal
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    module: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const f = field => (get(this.module, field) || "").substr(0, 19);
    return {
      openModal: false,
      days_to_release: !!get(this.module, "days_to_release", 0),
      release_at: this.module.release_at && f("release_at") !== f("created_at")
    };
  },
  methods: {
    openCategoryModal() {
      this.openModal = true;
    },
    categoryOnSuccess(newCategory) {
      this.openModal = false;
      this.$store.commit("membersCategories/setCategories", [
        ...this.categories,
        newCategory
      ]);
      this.form.category_ids.push(newCategory.id);
    }
  },
  computed: {
    ...mapState("membersCategories", ["categories"])
  },
  watch: {
    days_to_release(v) {
      if (!v) {
        this.form.days_to_release = 0;
      } else {
        this.release_at = false;
      }
    },
    release_at(v) {
      if (!v) {
        this.form.release_at = null;
      } else {
        this.days_to_release = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.product-details-content-register-module-basic {
  .subtitle {
    color: #3b3b4ae6;
    font-size: 16px;
    font-weight: 400;
  }
  .description {
    color: #77788ede;
    font-size: 13px;
  }
  .button {
    color: #3b3b4ae6;
    font-size: 15px;
    font-weight: 400;
  }
}
</style>
